import { LegendProps } from 'recharts';

type Props = LegendProps & {
  hoveredItem: string | null;
  setHoveredItem: (item: string | null) => void;
  barColors: Record<string, string>;
};

export const ContributingEpicsChartLegend = ({ hoveredItem, setHoveredItem, barColors, ...props }: Props) => {
  const { payload } = props as any;

  if (!payload) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        fontSize: '14px',
        color: '#555',
        fontWeight: 500,
      }}
    >
      {payload.map((entry: any) => {
        const dataKey = entry.dataKey;
        const color = barColors[dataKey as keyof typeof barColors];

        return (
          <div
            key={`legend-item-${entry.dataKey}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              padding: '6px 12px',
              borderRadius: '16px',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={() => setHoveredItem(entry.dataKey as string)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div
              style={{
                width: '8px',
                height: '8px',
                backgroundColor: color,
                marginRight: '8px',
              }}
            />
            <span>{entry.value}</span>
          </div>
        );
      })}
    </div>
  );
};
